import { NavigatorDrawingsProps } from 'components/commandpanel/Navigator/NavigatorDrawingIcons';
import { IPlateDropRegions } from 'business/models/Models';
import { Annotations } from 'components/Experiment/constants';

export const getNavigatorCommandPanelImageIcons = (
  plateDrawing: Annotations,
  disabledImageRegions: IPlateDropRegions[],
  wellNumber: number,
  dropNumber: number,
  regionName: string,
  cpId: number,
  imageBatchId: number,
) => {
  if (plateDrawing) {
    const getNavCondition = (x) => {
      return (
        x.wellNumber === wellNumber &&
        x.dropNumber === dropNumber &&
        x.regionName === regionName &&
        x.cpId === cpId
      );
    };

    const getAnnotAndROICondition = (x) => {
      return x.wellNumber === wellNumber && x.dropNumber === dropNumber;
    };

    const getScribbleCondition = (x) => {
      return x.wellNum === wellNumber && x.dropNum === dropNumber;
    };

    const getCrystalCondition = (x) => {
      return (
        x.wellNumber === wellNumber &&
        x.dropNumber === dropNumber &&
        x.regionName === regionName &&
        x.cpId === cpId &&
        x.imageBatchId === imageBatchId
      );
    };

    const result = {
      annotationIcon:
        plateDrawing.plateAnnotations?.find(getAnnotAndROICondition) &&
        regionName === 'Drop'
          ? true
          : false,
      disableImageIcon: !disabledImageRegions?.find(getNavCondition)?.imagingEnabled,
      roiIcon:
        plateDrawing.plateROI?.find(getAnnotAndROICondition) && regionName === 'Drop'
          ? true
          : false,
      histogramIcon: plateDrawing.plateHistograms?.find(getNavCondition) ? true : false,
      scribbleIcon: plateDrawing.plateScribblesDetail?.wellNumsContainingScribbles?.find(
        getScribbleCondition,
      )
        ? true
        : false,
      crystalIcon: plateDrawing.plateCrystalIdentifiers?.find(getCrystalCondition)
        ? true
        : false,
    } as NavigatorDrawingsProps;
    return result;
  }
};
